import { apiClient } from 'api'
import { GameLink } from 'types/games-links'

export const getGameLinks = (gameId: number) => apiClient.get<GameLink[]>(`/games-links/game/${gameId}`)

export const addLinkToGame = (data: GameLink) => apiClient.post<GameLink, GameLink>(`/games-links`, data)

export const deleteLinkFromGame = (gameLinkId: number) => apiClient.delete(`/games-links/${gameLinkId}`)

export const editLinkFromGame = (gameLinkId: number, data: GameLink) =>
    apiClient.patch(`/games-links/${gameLinkId}`, data)
